define.alias("ember-basic-dropdown/components/basic-dropdown-trigger", "calendar/components/basic-dropdown-trigger");